import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';
import { FaSearch, FaTimes } from 'react-icons/fa';

export const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin-top: -1px; /* margin-top to account for small spacing rendering issue */
  z-index: 2;
`;

export const InputContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  position: relative;

  @media ${sizes.tabletLandscape} {
    width: 450px;
  }
`;

export const TextInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 5px;
  margin: 0;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${th('colors.white')};
  font-size: 16px;
  color: ${th('colors.white')};
  background-color: transparent;

  ::placeholder {
    color: #e5e5e5;
  }

  :focus {
    outline: none;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 10px;
`;

export const SearchIcon = styled(FaSearch)`
  position: relative;
  color: ${th('colors.white')};
`;

export const CancelIcon = styled(FaTimes)`
  position: relative;
  cursor: pointer;
  color: ${th('colors.white')};
`;
